import React from 'react';
import './About.css'; // Assurez-vous que le fichier CSS existe et est stylé

function About() {
  return (
    // Section "À Propos" avec l'ID pour la navigation
    <section id="about" className="about-section">
      <div className="container"> {/* Conteneur pour centrer et limiter la largeur */}
        {/* Titre adapté pour le salon de coiffure */}
        <h2 className="section-title">Bienvenue chez Studio Ambre</h2>

        <div className="about-content">
          {/* Partie Texte adaptée pour Studio Ambre */}
          <div className="about-text">
            <p>
              Découvrez un espace dédié à la beauté de vos cheveux, où <strong>professionnalisme, détente et naturalité</strong> se rencontrent.
            </p>
            <p>
              Notre équipe passionnée met son savoir-faire et son écoute à votre service pour réaliser la coupe,
              la couleur, le balayage ou le soin qui mettra en valeur votre style unique. Nous privilégions une
              <strong> approche consciente</strong> en utilisant des <strong>produits de qualité professionnelle et d'origine naturelle</strong>,
              notamment nos colorations 100% végétales Couleurs Gaïa et nos soins UMAÏ, <strong>respectueux de vos cheveux et de l'environnement</strong>.
            </p>
            <p>
              Poussez la porte de Studio Ambre pour un diagnostic personnalisé, des conseils avisés et un moment de bien-être unique.
              Nous sommes impatients de vous accueillir !
            </p>
          </div>

          {/* Partie Image - LE CONTENEUR EST MAINTENANT LE PARENT POUR LE POSITIONNEMENT */}
          <div className="about-image-wrapper">
            <img
              src="/images/about.jpeg"
              alt="Logo de Studio Ambre, salon de coiffure à Samatan"
              className="about-image"
              loading="lazy"
            />
            {/* LOGO MAITRE ARTISAN */}
            <img
              src="/images/logomaitre.png"
              alt="Logo Maître Artisan"
              className="maitre-artisan-logo"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;